import { LegacyRef, useEffect, useRef, useState } from "react";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import { Label } from "../../screens/complaint/Complaint.styled";
import General from "../../stores/GeneralStore";

import { observer } from "mobx-react";
import User from "../../stores/UserStore";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  ButtonsContainer,
  InfoContainer,
  TabContainer,
} from "../../components/move-inRegistrationTabs/move-inTabs.styled";
import "../../components/Temporary Components/temp.css";
import socialCaseRequestStore from "../../stores/SocialCaseRequestStore";
import { NotifySuccess } from "../../utils/ShowSuccess";
import { NotifyError } from "../../utils/ShowError";
import * as Yup from "yup";

import { BaseProps } from "../../components/move-inRegistrationTabs/interfaces";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
interface Obj {
  [key: string]: string | {} | [];
}

const documentTypes: Obj = {
  passport: "Passport",
  emiratesid: "Emirates ID",
  familybook: "Family Book",
  salary: "Salary or Retirement Certificate",
  titledeed: "Title Deed",
  bankstatement: "Bank Statement (last 3 months)",
  dedcertificate: "Property Certificate from Land Dept.",
  municipalitycertificate: "Property Certificate from Ajman Municipality",
};



interface Props extends BaseProps {
  details: any;
  onCross: any;
  status?:any
}
const InformationModal = ({ details, onCross,status }: Props) => {
  const emirateValue = useRef<HTMLSelectElement | null>(null);
  const [updateLoader,setupdateLoader]=useState(false)

  const validationSchema = Yup.object().shape({
    poBoxValue: Yup.string()
      .required(General?.codeLabels["cm_man_pobox"]?.label? General?.codeLabels["cm_man_pobox"]?.label: "PO Box Number is required")
      .matches(/^[0-9]+$/, General?.codeLabels["cm_numbererror"]?.label? General?.codeLabels["cm_numbererror"]?.label: "PO Box Number must contain only digits"),
  });
  const [loader,setLoaderDownload]=useState(false);
  const [loaderIndex,setloaderIndex]=useState<any>();

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;
  const handleSubmit =async (values: any) => {
    setupdateLoader(true);
    const poBox = values.poBoxValue; 
    const emirate = emirateValue.current?.value;
    const data:any = {
      poBox,
      emirate,
    }
   try{
     const res= await User.updatePobox({ errorId: "updateBankDetailsError", data });
    if(res?.statusCode=='200'){
      onCross()
      setupdateLoader(false)
      await User.getPoboxData({
        errorId: "getBankDataError",
        data: User.info.personId,
      });
      await  User.getProfile(User.info.personId as string);
    }else if(!res){
      NotifyError(General?.codeLabels['cm_servererror']?.label)
      setupdateLoader(false)
      onCross()
    }
  }catch(error){
      onCross()
      setupdateLoader(false)
    }
  };

  return (
    <div
      style={{
        zIndex: 9999,
        backgroundColor: "#fff",
        overflow: "auto",
        height: "40%",
        width:General?.isLargeScreen? "80%":"100%",
        margin: "auto",
        direction:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"? "rtl": "ltr",
      }}
    >
      <div
        style={{
          backgroundColor: General?.colorClass? General?.colorClass: "#101e8e",
          padding: "20px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h1 id="modal-title" style={{ color: "white", margin: 0 }}>
        {General?.codeLabels['cm_custinfoupdateheader']?.label?General?.codeLabels['cm_custinfoupdateheader']?.label:"Customer Information Update"}
        </h1>

      </div>
      <TabContainer style={{ padding: "25px",display:General?.isLargeScreen?"grid":"flex",flexDirection:General?.isLargeScreen?"row":"column"}}>
      <Formik
        initialValues={{
          poBoxValue: User?.poBoxData?.city,
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        <Form>
        <InfoContainer style={{display:"flex",flexDirection:General?.isLargeScreen?"row":"column",width:General?.isLargeScreen?"":"100%"}}>

      <Label
              className={General?.textClass}
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  lineHeight: "16px",
                  gap: "0.5rem",
                  height: "100px",
                  width:General?.isLargeScreen?"":"100%"
                }}
              >
                {General?.codeLabels["cm_pobox"]?.label !== undefined
                  ? General?.codeLabels["cm_pobox"]?.label
                  : "PO Box Number"}
                *
                <Field
                  type="number"
                  // defaultValue={User?.poBoxData?.city}
                  // value={User?.poBoxData?.city}
                  // innerRef={}
                  style={{
                    background: "#e5eff2",
                    color: "#101E8E",
                    fontSize: `${General.accessibility.fontSize}rem`,
                  }}
                  name="poBoxValue" 
                  className={General?.textClass}
                />
                <div style={{height:'0.5rem'}}> <ErrorMessage
                  name="poBoxValue" 
                  component="div"
                  className="error-message"
                /></div>
               
              </Label>
              <Label
              className={General?.textClass}
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                  fontFamily: "Segoe UI",
                  fontStyle: "normal",
                  fontWeight: "700",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  lineHeight: "16px",
                  gap: "0.5rem",
                  height: "100px",
                  width:General?.isLargeScreen?"":"100%"
                }}
              >
                {General?.codeLabels["cm_emirate"]?.label !== undefined? General?.codeLabels["cm_emirate"]?.label: "Emirate"}*
                <select
                className={General?.textClass}
                  style={{
                    color: "#101E8E",
                    fontSize: `${General.accessibility.fontSize}rem`,
                  }}
                  ref={emirateValue}
                >
                  <option
                  className={General?.textClass}
                    selected={User?.poBoxData?.state == "ABU DH" ? true : false}
                    key={"ABU DH"}
                    value="ABU DH"
                  >
                    {General?.codeLabels["cm_abudhabi"]?.label !== undefined
                      ? General?.codeLabels["cm_abudhabi"]?.label
                      : "Abu Dhabi"}
                  </option>
                  <option
                  className={General?.textClass}
                    selected={User?.poBoxData?.state == "AJMAN" ? true : false}
                    key={"AJMAN"}
                    value="AJMAN"
                  >
                    {" "}
                    {General?.codeLabels["cm_ajman"]?.label !== undefined
                      ? General?.codeLabels["cm_ajman"]?.label
                      : "Ajman"}
                  </option>
                  <option
                  className={General?.textClass}
                    selected={User?.poBoxData?.state == "DUBAI" ? true : false}
                    key={"DUBAI"}
                    value="DUBAI"
                  >
                    {General?.codeLabels["cm_dubai"]?.label !== undefined
                      ? General?.codeLabels["cm_dubai"]?.label
                      : "Dubai"}
                  </option>
                  <option
                  className={General?.textClass}
                    selected={User?.poBoxData?.state == "FUJAIR" ? true : false}
                    key={"FUJAIR"}
                    value="FUJAIR"
                  >
                    {" "}
                    {General?.codeLabels["cm_fujairah"]?.label !== undefined
                      ? General?.codeLabels["cm_fujairah"]?.label
                      : "Fujairah"}
                  </option>
                  <option
                  className={General?.textClass}
                    selected={User?.poBoxData?.state == "RAS AL" ? true : false}
                    key={"RAS AL"}
                    value="RAS AL"
                  >
                    {" "}
                    {General?.codeLabels["cm_rasalkhaimah"]?.label !== undefined
                      ? General?.codeLabels["cm_rasalkhaimah"]?.label
                      : "Ras Al Khaimah"}
                  </option>
                  <option
                  className={General?.textClass}
                    selected={User?.poBoxData?.state == "SHARJA" ? true : false}
                    key={"SHARJA"}
                    value="SHARJA"
                  >
                    {General?.codeLabels["cm_sharjah"]?.label !== undefined
                      ? General?.codeLabels["cm_sharjah"]?.label
                      : "Sharjah"}
                  </option>
                  <option
                  className={General?.textClass}
                    selected={User?.poBoxData?.state == "UMM AL" ? true : false}
                    key={"UMM AL"}
                    value="UMM AL"
                  >
                    {" "}
                    {General?.codeLabels["cm_ummalquwain"]?.label !== undefined
                      ? General?.codeLabels["cm_ummalquwain"]?.label
                      : "Umm Al Quwain"}
                  </option>
                </select>
                <div style={{height:'0.5rem'}}></div>
              </Label>
      </InfoContainer>
      <ButtonsContainer
              style={{ width:"100%", gap: "1rem",display:'flex',justifyContent:"center",marginTop:'1rem' }}
            >
              <ButtonSecondary
                type="submit"
                style={{
                  width: General?.isLargeScreen?"228px":"100%",
                  height: "50px",
                  fontWeight: "bold",
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: contrast?.contrastBackground
                    ? contrast?.contrastBackground
                    : "#fff",
                  background: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#101e83",
                }}
                className={General?.colorClass}
              >
                {updateLoader?<Spinner width="30px" height="30px" />: General?.codeLabels["cm_update"]?.label !== undefined
                  ? General?.codeLabels["cm_update"]?.label
                  : "UPDATE"}
              </ButtonSecondary>
            </ButtonsContainer>
              </Form>
      </Formik>
      </TabContainer>
    </div>
  );
};

export default observer(InformationModal);
